import { render, staticRenderFns } from "./Operacion.vue?vue&type=template&id=60505630&scoped=true&"
import script from "./Operacion.vue?vue&type=script&lang=js&"
export * from "./Operacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60505630",
  null
  
)

export default component.exports